module.exports = __webpack_public_path__ + "img/IT0003255090574.6f102676.png";